import { makeStyles } from '@material-ui/core';
import { createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    viewBtn: {
      width: '100%',
      textTransform: 'none',
      textAlign: 'center',
      fontSize: 16,
      lineHeight: 1,
      padding: 20,
      color: '#B5B1C1',
      background: '#3A354D',
      borderRadius: 5,
      fontWeight: 'bold',
      [theme.breakpoints.up('md')]: {
        fontSize: 18,
      },
      '@media (hover: none)': {
        '&:hover': {
          backgroundColor: '#3A354D',
        },
      },
    },
  }),
);

export default useStyles;
